import React from 'react';
import { integerToLetter } from '../../../../../../../../../../../../../../../utils/transformations';
import BulletIcon from '../../../../../../../../../../../../../../../assets/svg/circle-dot.svg';
import SortIcon from '../../../../../../../../../../../../../../../assets/svg/sortWithTwoLines.svg';
import styles from './optionIcon.css';
import { PersTypesPopup } from '../../../../../persTypesPopup/PersTypesPopup';

/**
 *
 * @type {React.NamedExoticComponent<{readonly actionOnClick?: *, readonly sortType?: *, readonly numberType?: *, readonly elementHandle?: *, readonly letterType?: *, readonly answer?: *, readonly elementStyle?: *, readonly keyNumber?: *, readonly bulletType?: *, readonly type?: *}>}
 */
const OptionIcon = React.memo( ( { type, answer, bulletType, numberType, letterType, sortType, keyNumber, elementStyle, actionOnClick, elementHandle } ) => {

    const getIcon = () => {
        if ( type === 'person' && answer && answer.person_types_conformity_answers ) {
            return <PersTypesPopup answer={ answer }/>;
        } else if ( bulletType ) {
            return <BulletIcon className={ styles.bulletIcon }/>;
        } else if ( numberType ) {
            return keyNumber + 1;
        } else if ( letterType ) {
            return integerToLetter( keyNumber ).toUpperCase();
        } else if ( sortType ) {
            return <SortIcon className={ styles.bulletIcon }/>;
        }
    };

    return (
        <div className={ styles.listType }
             onClick={ actionOnClick }>
            <div
                ref={ ( div ) => {
                    if ( elementHandle ) elementHandle[ keyNumber ] = div;
                } }
                style={ elementStyle }
                className={ styles.squarePoint }>
                    <span className={ styles.listTypeText }>
                        { getIcon() }
                    </span>
            </div>
        </div>
    );
} );

export default OptionIcon;
